export const translateMemberStatusReason = {
  DECEASED: 'Por falecimento',
  COMPANY_EMPLOYEE: 'Por ser funcionário',
  COMPANY_RESELLER: 'Por ser revendedor',
  PARTIAL_FRAUD: 'Por suspeita de fraude',
  FRAUD: 'Por fraude confirmada',
  MEMBER_REQUEST: 'Por solicitação do cliente',
  NEW_CLUB_MIGRATION: 'Por migração para novo clube',
  DONT_WANT_MIGRATE: 'Por não querer ser migrado',
  REGION_CHANGE: 'Por mudança de região',
  UNINFORMED: 'Motivo não informado',
  PRE_MIGRATION: 'Em processo de migração',
  INVALID_DATA: 'Dados cadastrais inválidos',
  FRAUD_THIRD_LINKED: 'Fraude por terceiro vinculado',
  UNBLOCK_BLOCKLIST: 'Desbloqueio - Blocklist',
  NEW_TELEPHONE_MIGRATION: 'Por migração para novo telefone'
}
